<div
   class="full-flex-height justify-content-center align-items-center flex-row innerAppButton appButtons dvm-landing"
   style="flex-wrap: wrap; align-self: anchor-center; gap: 30px; max-width: 1200px"
   [style.padding-bottom]="isGlobalAdmin() ? '110px' : ''">
   <div
      *ngIf="isLoading"
      style="text-align: center; padding: 40px">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
   </div>

   <div
      class="search-row"
      *ngIf="isGlobalAdmin() && !isLoading">
      <div
         class="ph-search"
         (click)="$event.stopPropagation()">
         <div class="ph-search-field">
            <i class="fa fa-search ph-search-ico"></i>
            <input
               #si
               type="text"
               class="ph-search-input"
               placeholder="Search by reviewee name, hospital, or reviewer..."
               autocomplete="off"
               (focus)="onSearch(si.value)"
               (input)="onSearch(si.value)" />
            <i
               class="fa fa-spinner fa-spin ph-search-ico"
               *ngIf="searching"></i>
            <button
               type="button"
               class="ph-search-clear"
               *ngIf="searchTerm"
               (click)="si.value = ''; onSearch(''); si.focus()">
               &times;
            </button>
         </div>

         <div
            class="ph-results"
            *ngIf="searchTerm.trim().length > 1 && searchResults.length">
            <div
               class="ph-empty"
               *ngIf="searching">
               <i class="fa fa-spinner fa-spin"></i>
               &nbsp;Searching...
            </div>
            <div
               class="ph-empty"
               *ngIf="!searching && !searchResults.length">
               No one matches "{{ searchTerm }}".
            </div>

            <div
               class="ph-row"
               *ngFor="let u of searchResults">
               <div class="ph-row-main">
                  <span
                     class="ph-av"
                     [style.background]="avatarBg(u.revieweeDisplayName)"
                     [style.color]="avatarFg(u.revieweeDisplayName)">
                     {{ initials(u.revieweeDisplayName) }}
                  </span>

                  <div class="ph-id">
                     <div class="ph-name">
                        {{ u.revieweeDisplayName }} &nbsp;
                        <span
                           class="status-dot"
                           [style.color]="
                              u.revieweeUserStatus == 'ACTIVE'
                                 ? '#00a977'
                                 : u.revieweeUserStatus == 'LOAINACTIVE'
                                   ? '#ebb32d'
                                   : u.revieweeUserStatus == 'TERMINATED'
                                     ? '#cd1402'
                                     : ''
                           ">
                           • {{ u.revieweeUserStatus }}
                        </span>
                     </div>
                     <div class="ph-hosp">
                        <span *ngIf="u.practiceName">{{ u.practiceName }}</span>
                     </div>
                  </div>

                  <span
                     class="ph-chip"
                     *ngIf="cycleOf(u)"
                     [ngClass]="cycleClass(u)">
                     {{ cycleOf(u) }}
                  </span>
                  <span
                     class="ph-chip ph-chip-type"
                     *ngIf="typeOf(u)">
                     {{ typeOf(u) }}
                  </span>
                  <span
                     class="ph-chip ph-cyc-team"
                     *ngIf="isUnset(u)">
                     TEAM
                  </span>
                  <button
                     type="button"
                     class="ph-btn ph-btn-set"
                     *ngIf="isUnset(u)"
                     (click)="goToRoster(u, $event)">
                     <span
                        class="ph-bang"
                        aria-hidden="true">
                        !
                     </span>
                     &nbsp;Set missing review type
                  </button>

                  <div class="ph-actions">
                     <button
                        type="button"
                        class="ph-btn ph-btn-alt"
                        *ngIf="u.reviewCount"
                        (click)="toggleReviewees(u, $event)">
                        {{ u.reviewCount }} Reviewees&nbsp;
                        <i
                           class="fa"
                           [ngClass]="expandedId === u.revieweeUserId ? 'fa-caret-up' : 'fa-caret-down'"></i>
                     </button>
                     <a
                        class="ph-open"
                        *ngIf="reviewRt(u)"
                        [routerLink]="['/performance-hub', reviewPath(u), u.revieweeUserId]"
                        [queryParams]="{ rt: reviewRt(u) }"
                        target="_blank"
                        rel="noopener">
                        <i class="fa fa-envelope-open-text"></i>
                        &nbsp;Open review
                     </a>
                     <a
                        class="ph-open"
                        *ngIf="u.practiceName"
                        [href]="'./performance-hub/admin/user-management?practice=' + encodeURIComponent(u.practiceName)"
                        target="_blank"
                        rel="noopener">
                        <i class="fa fa-building"></i>
                        &nbsp;Hospital roster
                     </a>
                     <a
                        class="ph-open-user"
                        [href]="
                           './performance-hub/admin/user-management?userId=' + u.revieweeUserId + '&revieweeDisplayName=' + u.revieweeDisplayName + ''
                        "
                        rel="noopener"
                        target="_blank">
                        <i class="fa fa-user"></i>
                        &nbsp;View user&nbsp;
                        <i class="fa fa-external-link"></i>
                     </a>
                  </div>
               </div>

               <div
                  class="ph-sub ph-history"
                  *ngIf="u._past">
                  <div class="ph-sub-row">
                     <div class="ph-id">
                        <span class="ph-hist-label"></span>
                     </div>
                     <span class="prev-role">{{ u.revieweeDisplayName }}'s previous role:</span>
                     &nbsp;{{ reviewRt(u._past) }}
                     <div class="ph-actions">
                        <a
                           class="ph-open ph-open-past"
                           *ngIf="reviewRt(u._past)"
                           href="javascript:void(0)"
                           rel="noopener"
                           [routerLink]="['/performance-hub', reviewPath(u), u.revieweeUserId]"
                           [queryParams]="{ rt: reviewRt(u._past) }"
                           target="_blank">
                           <i class="fa fa-history"></i>
                           &nbsp;Open review&nbsp;
                           <i class="fa fa-external-link"></i>
                        </a>
                     </div>
                  </div>
               </div>

               <!-- Dual role: the people this person reviews -->
               <div
                  class="ph-sub"
                  *ngIf="expandedId === u.revieweeUserId">
                  <div
                     class="ph-sub-row"
                     *ngIf="u._loadingReviewees">
                     <i class="fa fa-spinner fa-spin"></i>
                     &nbsp;Loading...
                  </div>

                  <div
                     class="ph-sub-row"
                     *ngFor="let r of u._reviewees">
                     <div class="ph-id">
                        <span class="ph-sub-name">{{ r.revieweeDisplayName }}</span>
                        &nbsp;&nbsp;
                        <span class="ph-sub-hosp">{{ r.practiceName }}</span>
                     </div>

                     <span
                        class="ph-chip"
                        *ngIf="cycleOf(r) && !isUnset(r)"
                        [ngClass]="cycleClass(r)">
                        {{ cycleOf(r) }}
                     </span>
                     <span
                        class="ph-chip ph-chip-type"
                        *ngIf="typeOf(r)">
                        {{ typeOf(r) }}
                     </span>
                     <span
                        class="ph-chip ph-cyc-team"
                        *ngIf="isUnset(r)">
                        TEAM
                     </span>
                     <button
                        type="button"
                        class="ph-btn ph-btn-set"
                        *ngIf="isUnset(r)"
                        (click)="goToRoster(r, $event)">
                        <span
                           class="ph-bang"
                           aria-hidden="true">
                           !
                        </span>
                        &nbsp;Set missing review type
                     </button>

                     <div
                        *ngIf="reviewRt(r)"
                        class="ph-actions">
                        <a
                           class="ph-open"
                           *ngIf="reviewRt(r)"
                           [routerLink]="['/performance-hub', reviewPath(r), r.revieweeUserId]"
                           [queryParams]="{ rt: reviewRt(r) }"
                           target="_blank"
                           rel="noopener">
                           <i class="fa fa-envelope-open-text"></i>
                           &nbsp;Open review
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <ng-container *ngIf="!isLoading">
      <!-- aDVM Self-Assessment: Show to DVMs (reviewees) and COSs (reviewers), plus higher-level viewers -->
      <a
         *ngIf="(shouldDisplayDVMTile && (isDVM || isHM || isRM || isCOS || isCOSA || isOpsDirector || isOpsVP)) || isGlobalAdmin()"
         href="./performance-hub/reviews?rt=DVM"
         class="box"
         style="width: 240px">
         <div class="card">
            <div class="card-body">
               <h1 class="card-title ico text-center appButton-teal">
                  <i class="fa fa-stethoscope"></i>
               </h1>
               <h4 class="text-center landing-main">aDVM Self-Assessment &</h4>
               <h4 class="text-center landing-sub">COS Review for aDVM</h4>
            </div>
         </div>
      </a>

      <!-- HM Self-Assessment: Show to HMs (reviewees) and RMs (reviewers), plus higher-level viewers -->
      <a
         *ngIf="isHM || isRM || isCOSA || isOpsDirector || isOpsVP || isGlobalAdmin()"
         href="./performance-hub/reviews?rt=HM"
         class="box"
         style="width: 240px">
         <div class="card">
            <div class="card-body">
               <h1 class="card-title ico text-center appButton-blue">
                  <i class="fas fa-hospital-user"></i>
               </h1>
               <h4 class="text-center landing-main">HM Self-Assessment &</h4>
               <h4 class="text-center landing-sub">RM Review for HM</h4>
            </div>
         </div>
      </a>

      <!-- COS Self-Assessment: Show to COSs (reviewees) and COSA/RMs (reviewers), plus higher-level viewers -->
      <a
         *ngIf="isCOS || isCOSA || isRM || isOpsDirector || isOpsVP || isGlobalAdmin()"
         href="./performance-hub/reviews?rt=COS"
         class="box"
         style="width: 240px">
         <div class="card">
            <div class="card-body">
               <h1 class="card-title ico text-center appButton-purple">
                  <i class="fas fa-user-md"></i>
               </h1>
               <h4 class="text-center landing-main">COS Self-Assessment &</h4>
               <h4 class="text-center landing-sub">COSA/RM Review for COS</h4>
            </div>
         </div>
      </a>

      <!-- RM Self-Assessment: Show to RMs (reviewees) and DOs (reviewers), plus higher-level viewers -->
      <a
         *ngIf="isRM || isOpsDirector || isOpsVP || isGlobalAdmin()"
         href="./performance-hub/reviews?rt=RM"
         class="box"
         style="width: 240px">
         <div class="card">
            <div class="card-body">
               <h1 class="card-title ico text-center appButton-yellow">
                  <i class="fas fa-user-tie"></i>
               </h1>
               <h4 class="text-center landing-main">RM Self-Assessment &</h4>
               <h4 class="text-center landing-sub">DO Review for RM</h4>
            </div>
         </div>
      </a>

      <!-- DO Self-Assessment: Show to DOs (reviewees) and VPs (reviewers) -->
      <a
         *ngIf="isOpsDirector || isOpsVP || isGlobalAdmin()"
         href="./performance-hub/reviews?rt=DO"
         class="box"
         style="width: 240px">
         <div class="card">
            <div class="card-body">
               <h1 class="card-title ico text-center appButton-orange">
                  <i class="fas fa-briefcase"></i>
               </h1>
               <h4 class="text-center landing-main">DO Self-Assessment &</h4>
               <h4 class="text-center landing-sub">VP Review for DO</h4>
            </div>
         </div>
      </a>

      <a
         href="./performance-hub/team-reviews?rt=TEAM"
         *ngIf="(shouldDisplayTeamTile && !isDVM) || isGlobalAdmin()"
         class="box"
         style="width: 240px">
         <div class="card">
            <div
               class="card-body"
               style="position: relative">
               <div class="new-tag">NEW</div>
               <h1 class="card-title ico text-center appButton-red">
                  <i class="fas fa-users"></i>
               </h1>
               <h4 class="text-center landing-main">Team Member Self-Assessment</h4>
               <h4 class="text-center landing-sub">& Manager Review</h4>
            </div>
         </div>
      </a>

      <a
         *ngIf="isGlobalAdmin() || shouldDisplayOpenTile"
         [href]="'./performance-hub/reviews?rt=' + openTileRt"
         class="box"
         style="width: 240px">
         <div
            class="card"
            style="padding: 10px; height: 170px">
            <div
               class="card-body"
               style="border: 1px dashed #b9b9b9">
               <i
                  class="fas fa-folder-open"
                  style="color: #016160; font-size: 15px"></i>
               &nbsp;
               <span style="color: #016160; font-size: 14px; text-transform: uppercase; letter-spacing: 0.8px; font-weight: 600">Open Cycle</span>
               <h4
                  class="text-center landing-sub"
                  style="font-size: 11px !important; color: #565656; line-height: 15px; margin-top: 8px !important">
                  For employees moved outside their assigned review cycle
               </h4>
            </div>
         </div>
      </a>

      <div
         class="admin-access-section"
         *ngIf="isGlobalAdmin()">
         <div class="admin-banner">
            <div class="admin-banner-content">
               <div class="admin-banner-text">
                  <i
                     class="fa fa-bar-chart"
                     style="font-size: 33px"></i>
                  <div>
                     <h3 class="admin-banner-title">Admin Access</h3>
                     <p class="admin-banner-description">View analytics, manage users, & export data</p>
                  </div>
               </div>
               <button
                  class="admin-dashboard-btn"
                  (click)="navigateToAdminDashboard()">
                  <span>View Admin Dashboard</span>
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     class="btn-icon"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke="currentColor">
                     <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7" />
                  </svg>
               </button>
            </div>
         </div>
      </div>
   </ng-container>
</div>

<div
   class="landing-messages"
   *ngIf="!isLoading && (hasMessages || isGlobalAdmin())">
   <span class="msg-bubble-container">
      <i class="fa fa-message"></i>
      <span
         class="msg-bubble"
         *ngIf="messageCount">
         {{ messageCount }}
      </span>
   </span>

   <span>
      You have
      <strong>{{ messageCount > 0 ? messageCount : "0" }}</strong>
      new message{{ messageCount == 1 ? "" : "s" }}
   </span>
   <button
      class="v-button v-button-md v-white"
      (click)="showMessages = true"
      style="color: #005e5d">
      View
   </button>
</div>

<div
   class="messages-modal-overlay"
   *ngIf="showMessages"
   (click)="closeMessages()">
   <div
      class="messages-modal"
      (click)="$event.stopPropagation()">
      <button
         type="button"
         class="messages-modal-close"
         (click)="closeMessages()">
         <i class="fa fa-xmark"></i>
      </button>

      <app-admin-messages></app-admin-messages>
   </div>
</div>
